<template>
  <div class="nd-checkbox-group w-full scrollbar">
    <n-checkbox-group v-model:value="computedValue" class="w-full">
      <template v-for="item in props.options" :key="item.id">
        <div class="px-5 py-3 hover:bg-gray-20 transition-colors" :class="props.itemClass">
          <n-checkbox class="w-full" :value="item.id" :label="item.name" />
        </div>
      </template>
    </n-checkbox-group>
    <scroll-mask v-if="showMask" />
  </div>
</template>

<script setup lang="ts">
import { NCheckboxGroup, NCheckbox } from 'naive-ui'

const modelValue = defineModel<string[] | number[]>('modelValue')
const value = defineModel<string[] | number[]>('value')

const computedValue = computed({
  get() {
    return modelValue.value || value.value
  },
  set(newValue) {
    modelValue.value = newValue
    value.value = newValue
  },
})

const props = withDefaults(
  defineProps<{
    options?: {
      id: string | number | undefined
      name: string | undefined
    }[]
    itemClass?: string
    showMask?: boolean
  }>(),
  {
    options: () => [],
    itemClass: '',
    showMask: false,
  }
)
</script>

<style lang="scss" scoped>
.nd-checkbox-group {
}
</style>
